<template>
  <!-- 赠险保单 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">承保时间</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.status" :transfer="true" clearable>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="input-item">
          <span class="label">订单号</span>
          <Input v-model="searchParams.orderNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">投保单号</span>
          <Input v-model="searchParams.proposalNo" placeholder="请输入" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>
      <!-- 工具栏 -->
      <div class="tools-box right">
        <Button type="primary" @click="daochu">导出</Button>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="bar">
            <span @click="$refs.detailModal.open(row)" class="table-btn">详情</span>
            <span v-if="row.displayElectronicPolicy == 1" @click="downloadPolicy(row)" class="table-btn">电子保单</span>
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
      </div>
    </div>
    <!-- 电子保单地址 -->
    <a ref="policyNoBox" :href="policyNo" target="_black"></a>
    <!-- 线上保单详情  -->
    <detail-modal ref="detailModal"></detail-modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import detailModal from '@/pages/orderManage/insuredOrder/components/detailModal';
import _ from 'lodash';
import { pageTool } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, config],
  components: {
    confirmModal,
    selectTree,
    detailModal
  },
  data() {
    return {
      policyNo: '',//下载的电子保单
      companyList: [], //保司列表
      //过滤项
      searchParams: {
        groupIds: [],
        queryGift: '1',
        isAbnormal: '0',
        applyOrgId: '',
        isSelfHold: '',
        isMutualHold: '',
        userType: '1',
        selectType: '1',
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  computed: {},
  created() {
    this.initListParams('/buz/policy/read/list');
    this.getCompanyList();
  },
  activated() {
    this.getList();
  },
  methods: {
    //获取电子保单
    async downloadPolicy(item) {
      const res = await this.$http({
        url: '/buz/policy/getDownloadUrl',
        type: 'GET',
        data: {
          policyNo: item.policyNo
        },
        apiPermissionCode: 'order_30_7'
      });
      if (res.data) {
        this.policyNo = res.data;
        const target = this.$refs.policyNoBox;
        this.$nextTick(() => {
          target.click();
        });
      }
    },
    daochu() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/policy/policyExport', params, 'POST');
    },
    // 设置权限头
    setReqParams(params) {
      params.apiPermissionCode = 'order_90_2_0';
    },
    // 转化参数
    setListParams(params) {
      if (params.date && params.date[0]) {
        //承保时间
        params.insureTimeBegin = params.date[0];
        params.insureTimeEnd = params.date[1];
      }
      delete params.selectType;
      delete params.date;
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;
      delete params.applyOrgId;
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
